// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"21677b3d","633":"8ae4cf6d","794":"31f3c2bc"}[chunkId] + ".chunk.css";
};